@if (whitelabelService.isApplicationWhitelabelLoaded) {
  <div class="auth__container" [class.whitelabeled]="whitelabelService.isWhitelabel()">
    <div class="container">
      <div class="autentique-logo-holder">
        <img class="autentique-logo" [src]="whitelabelService.whitelabel?.logo" alt="" />
      </div>

      <ng-content class="container"></ng-content>

      <div class="terms">
        <a [href]="appService.termsOfUseAddress" class="terms-item">{{ 'external.useTerm' | translate }}</a>
        <a [href]="appService.privacyPolicyAddress" class="terms-item">{{ 'external.privacyPolicy' | translate }}</a>
      </div>
    </div>
  </div>

  <app-auth-brand-container [backToRegister]="backToRegister" [class.d-none]="whitelabelService.isWhitelabel()"></app-auth-brand-container>
}
